import './styles.scss'
import * as React from "react";
import {Display} from "../../../components/Display";
import {EmptyState, infoIcons} from "@vebox/etui-core";
import {AppTranslations} from "../../../components/Utils/translations/AppTranslations";
import {CensusListElement} from "../../components/CensusListElement";
import InfiniteScroll from "react-infinite-scroll-component";
import {Loader} from "../../../components/Utils/loader/Loader";
import {CensusListContext} from "../../providers/CensusListProvider";

declare var AppTranslations: AppTranslations;

interface CensusListProps {
}

export const CensusList: React.FC<CensusListProps> = () => {
    const {flattenedData, error, isFetching, hasNextPage, handleOnLoadNextPage, totalCount} = React.useContext(
        CensusListContext);

    return (
        <div style={{overflow: "auto", height: '100%'}}>
            <Display isVisible={flattenedData && !isFetching && !error}>
                <InfiniteScroll
                    dataLength={flattenedData.length} //This is important field to render the next data
                    next={handleOnLoadNextPage}
                    scrollThreshold={0.6}
                    hasMore={hasNextPage}
                    loader={<Loader relativelyCentered={true} spinnerSize={1}/>}
                >
                    {flattenedData?.map((census) => {
                            return <CensusListElement key={census.guid} census={census}/>
                        }
                    )}
                </InfiniteScroll>
            </Display>
            <Display isVisible={totalCount === 0 && !isFetching}>
                <EmptyState>
                    <EmptyState.InfoIcon
                        styles={{
                            root: {
                                color: "inherit",
                            }
                        }}
                        glyph={infoIcons.NoContent}
                    />
                    <EmptyState.Title color="inherit">{AppTranslations.noDataAvailable}</EmptyState.Title>
                </EmptyState>
            </Display>
        </div>
    )
}